import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { Tooltip } from 'react-tippy';
import { propStr, propArrayShape, propFunc, propOneOf, } from '../../../../helpers/custom-prop-types';
import RawSelect2Fields from '../../../Ui/Common/Fields/Select2Fields/RawSelect2Fields';
const ProfessionalUnitFilterSelect = (props) => {
    const { className, name, onChange, onClickForGuest, options: rawOptions, placeholder, userMode, } = props;
    const isViewable = userMode === 'view';
    const options = useMemo(() => {
        const color = '#f9f9f9';
        return [
            {
                color,
                id: '',
                label: 'All',
                value: '',
            },
            ...rawOptions.map((v) => (Object.assign(Object.assign({}, v), { color }))),
        ];
    }, [rawOptions]);
    return (_jsx(Tooltip, Object.assign({ animation: 'scale', arrow: true, disabled: isViewable, duration: 100, html: '会員の方のみ利用可能', position: 'top', trigger: 'mouseenter' }, { children: _jsx("div", Object.assign({ className: clsx('unit_filter_select', !isViewable && 'disabled', className), onClick: !isViewable ? onClickForGuest : undefined, role: 'presentation' }, { children: _jsx(RawSelect2Fields, { classNamePrefix: 'unit_filter_select', isDisabled: !isViewable, isMulti: false, name: name, onChange: onChange, options: options, placeholder: placeholder }) })) })));
};
ProfessionalUnitFilterSelect.propTypes = {
    className: propStr(),
    name: propStr().isRequired,
    onChange: propFunc().isRequired,
    onClickForGuest: propFunc(),
    options: propArrayShape().isRequired,
    placeholder: propStr(),
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
ProfessionalUnitFilterSelect.defaultProps = {
    className: '',
    onClickForGuest: undefined,
    placeholder: '',
};
export default ProfessionalUnitFilterSelect;
